
import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import TransportationForm from '../TransportationForm';
import { TransportationDetails } from '@/types/itinerary';

interface TransportationTabContentProps {
  tabValue: string;
  details: TransportationDetails;
  onChange: (field: string, value: any) => void;
  onSave: () => void;
  formTitle: string;
  saveButtonText: string;
}

const TransportationTabContent: React.FC<TransportationTabContentProps> = ({
  tabValue,
  details,
  onChange,
  onSave,
  formTitle,
  saveButtonText
}) => {
  return (
    <TabsContent value={tabValue} className="mt-0">
      <TransportationForm
        details={details}
        onChange={onChange}
        onSave={onSave}
        formTitle={formTitle}
        saveButtonText={saveButtonText}
      />
    </TabsContent>
  );
};

export default TransportationTabContent;
